/*** IMPORTS FROM imports-loader ***/
var define = false;

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;

